var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.savePage
    ? _c(
        "div",
        [
          _vm.saveSuccess
            ? _c("CkNewSaveSusses")
            : _c("CkNewUpdateDetails", {
                attrs: { "on-save-update": _vm.onSave }
              })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }